// @ts-nocheck
import {Percent, CurrencyUSD, Time, GraphQLDecimal} from '@/graphql/scalars'

import * as Types from '../../../../../types/schema';

import { ClientProfileBasicFragment } from '../../../../clientProfiles/graphql/ClientProfile.generated';
import { gql } from '@apollo/client';
import { ClientProfileBasicFragmentDoc } from '../../../../clientProfiles/graphql/ClientProfile.generated';
export type PrimaryClientDropdown_HouseholdWithPrimaryClientsFragment = { __typename?: 'Household', id: string, possiblePrimaryClients: Array<(
    { __typename?: 'ClientProfile' }
    & ClientProfileBasicFragment
  )> };

export type PrimaryClientDropdown_PossibleGrantorFragment = (
  { __typename?: 'ClientProfile', isPrimary: boolean }
  & ClientProfileBasicFragment
);

export type PrimaryClientDropdown_HouseholdWithGrantorsFragment = { __typename?: 'Household', id: string, possibleGrantors: Array<(
    { __typename?: 'ClientProfile' }
    & PrimaryClientDropdown_PossibleGrantorFragment
  )> };

export const Operations = {
  Fragment: {
    PrimaryClientDropdown_HouseholdWithPrimaryClients: 'PrimaryClientDropdown_HouseholdWithPrimaryClients' as const,
    PrimaryClientDropdown_PossibleGrantor: 'PrimaryClientDropdown_PossibleGrantor' as const,
    PrimaryClientDropdown_HouseholdWithGrantors: 'PrimaryClientDropdown_HouseholdWithGrantors' as const
  }
}

/**
 * Custom plugin to wrap useQuery hooks with automatic context.fetchPolicy injection
 */
function withFetchPolicyContext(options) {
  const fetchPolicy = options?.fetchPolicy ?? 'cache-first';
  const isLazy = options?.isLazy ?? undefined;
  return {
    ...options,
    context: {
      ...options?.context,
      fetchPolicy,
      isLazy,
    },
  };
}

/**
 * Defaults useSubscription to ignoreResults: true so Apollo skips its
 * per-message useSyncExternalStore notification (forceStoreRerender). All
 * call sites manage state via onData; opting out avoids render storms when
 * messages arrive in a synchronous burst. See T2-10011. Callers that need
 * Apollo to surface data/loading/error can override by passing
 * ignoreResults: false explicitly.
 */
function withSubscriptionIgnoreResults(options) {
  return {
    ignoreResults: true,
    ...options,
  };
}

export const PrimaryClientDropdown_HouseholdWithPrimaryClientsFragmentDoc = gql`
    fragment PrimaryClientDropdown_HouseholdWithPrimaryClients on Household {
  id
  possiblePrimaryClients {
    ...ClientProfileBasic
  }
}
    ${ClientProfileBasicFragmentDoc}`;
export const PrimaryClientDropdown_PossibleGrantorFragmentDoc = gql`
    fragment PrimaryClientDropdown_PossibleGrantor on ClientProfile {
  ...ClientProfileBasic
  isPrimary
}
    ${ClientProfileBasicFragmentDoc}`;
export const PrimaryClientDropdown_HouseholdWithGrantorsFragmentDoc = gql`
    fragment PrimaryClientDropdown_HouseholdWithGrantors on Household {
  id
  possibleGrantors {
    ...PrimaryClientDropdown_PossibleGrantor
  }
}
    ${PrimaryClientDropdown_PossibleGrantorFragmentDoc}`;